const qs        = require('query-string');
const endpoint  = require('@readcube/endpoint');

function parseEnv() {
  if (window.readcube_env) {
    return window.readcube_env;
  }
  const query = qs.parse(location.search);
  if (query.env) {
    return query.env;
  }
  const subdomain = location.hostname.split('.').shift();
  return subdomain == 'staging' ? 'staging' : 'production';
}

function parseDoi() {
  if (window.reader_data?.doi) {
    return reader_data.doi;
  }
  const query = qs.parse(location.search);
  if (query.doi) {
    return query.doi;
  }
  const path = decodeURIComponent(location.pathname);
  return (path.match(/10\.\d{3,9}.+/) || [])[0];
}

function notifyParent(type, data) {
  const receiver = window.opener || window.parent;
  if (receiver) {
    receiver.postMessage(Object.assign({}, data, { type: type }), '*');
  }
}

function libraryItemUrl({ collection_id, list_id, id }) {
  if (list_id) {
    return `${endpoint.app}/library/${collection_id}/list/${list_id}/item/${id}`;
  }
  return `${endpoint.app}/library/${collection_id}/item/${id}`;
}

module.exports = { parseEnv, parseDoi, notifyParent, libraryItemUrl };
